import { Component, Input } from '@angular/core';

export interface ToolFaq {
  q: string;
  a: string;
}

/**
 * The closer every tool page ends with (2026-09-22): "How It Works" (a lead, a few
 * paragraphs) and the tool's four FAQ entries. The same questions are served to
 * crawlers as FAQPage JSON-LD from seo-route-meta.js, so keep the two in step.
 * Sits after From The Blog; the page's own section list points at `sec-<sectionKey>`.
 */
@Component( {
  selector: 'app-tool-about',
  templateUrl: './tool-about.component.html',
  styleUrls: [ './tool-about.component.scss' ],
} )
export class ToolAboutComponent {
  @Input() title = 'How It Works';
  @Input() lead = '';
  /** paragraphs may carry inline html (strong, a) */
  @Input() paragraphs: string[] = [];
  @Input() faq: ToolFaq[] = [];
  /** the color pages tint their headings with the color on the page */
  @Input() accent: string | null = null;
  @Input() sectionKey = 'about';
  /** the tool rated at the very bottom of the page (owner, 2026-10-04); no rating block without it */
  @Input() ratingKey = '';
  @Input() ratingName = 'This Tool';
}
